import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acroles',
  templateUrl: './acroles.component.html',
  styleUrls: ['./acroles.component.scss']
})
export class AcrolesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
